export const errorMessageKorean: { [key: string]: string } = {
  "auth/email-already-in-use": "이미 사용 중인 이메일입니다.",
  "auth/invalid-email": "잘못된 이메일 형식입니다.",
  "auth/operation-not-allowed": "해당 작업이 허용되지 않습니다.",
  "auth/weak-password": "비밀번호가 6자 이상이어야 합니다.",
  "auth/user-disabled": "사용이 중지된 계정입니다.",
  "auth/user-not-found": "존재하지 않는 사용자입니다.",
  "auth/wrong-password": "잘못된 비밀번호입니다."
  // 추가 오류 코드와 메시지를 여기에 작성하세요.
};
